<ng-container
  [ngTemplateOutlet]="
    mdq?.matches || swiperMinWidth == 0 ? swiperDisplay : defaultDisplay
  "
>
</ng-container>

<ng-template #defaultDisplay>
  <div [class]="defaultClass ? defaultClass : ''">
    @for (tab of slides; track tab) {
      <ng-container *ngTemplateOutlet="tab.template"></ng-container>
    }
  </div>
</ng-template>
<ng-template #swiperDisplay>
  <div #swiperContainer class="swiper">
    <div class="swiper-wrapper">
      @for (tab of slides; track tab) {
        <div class="swiper-slide">
          <ng-container *ngTemplateOutlet="tab.template"></ng-container>
        </div>
      }
    </div>
    <div class="swiper-pagination"></div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</ng-template>
